import { useState } from "react";
import { PropTypes } from "prop-types";
import { IconButton, Menu, MenuItem } from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { Link } from "react-router-dom";
import { AmplifySignOut } from "@aws-amplify/ui-react";
import { buildAlumPath } from "../../../constants/routes";

const propTypes = {
  user: PropTypes.objectOf(PropTypes.any).isRequired,
};

const ProfileMenu = ({ user }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
        size="large"
      >
        <AccountCircle />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={handleClose}
          component={Link}
          to={buildAlumPath(user.attributes.sub)}
        >
          Profile
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <AmplifySignOut />
        </MenuItem>
      </Menu>
    </div>
  );
};

ProfileMenu.propTypes = propTypes;

export default ProfileMenu;
